<app-form (submit)="updateNote()">
    <div class="card">
        <div class="card-header">
            <h3 class="card-header-title">{{ note?.trim() ? 'Edit note' : 'Add note' }}</h3>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <app-form-field label="Notes">
                        <textarea [(ngModel)]="note" rows="10" class="form-control w-100"></textarea>
                    </app-form-field>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-flex justify-content-between">
                <a class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
                <button type="submit" class="btn btn-primary">Save changes</button>
            </div>
        </div>
    </div>
</app-form>
